import {Model} from '@vuex-orm/core';
import {db} from '@/plugins/firebase'
export default class FirebaseModel extends Model {
	static primaryKey = 'uid';
	static baseCollection;
	static firestore = db;

	static fields(){
		return {
			uid: this.attr(null),
			$isDirty: this.attr(false),
			$isNew: this.attr(false),
			$softDelete: this.attr(false),
			ref: this.attr(null),
		}
	}

	static ignoredFields(){
		return [
			'uid',
			'$isNew',
			'$isDirty',
			'$softDelete',
			'$id',
			'ref',
		]
	}

	static beforeUpdate(item){
		let original = JSON.stringify(this.find(item.uid));
		let changed = JSON.stringify(item);
		let itemChanged = original !== changed;
		if(!item.$isNew && itemChanged) {
			console.log('isDirty', item)
			item.$isDirty = true;
		}
		return itemChanged ? item : false
	}

	static add(amount = 1){
		let items = [];
		for(let i = 0; i < amount; i+=1){
			items.push(this.newItem())
		}
		return this.insert({data: items});
	}

	static newItem(preSetProperties = {}){
		return {
			...Object.keys(this.fields()).filter(key => !this.ignoredFields().includes(key)).reduce((obj, item) => {
				obj[item] = null
				return obj
			}, {$isNew: true}),
			...preSetProperties
		}
	}
	//store functions
	static collect(){
		return this.baseCollection;
	}
	static doc(document){
		return this.baseCollection.doc(document)
	}
	static async load({deleteAll= true, limit= null, order_by=null, where= null, document= null, save= true} = {}){
		let response = {exists: false, raw: null}
		console.log(`loading ${this.entity}`);
		if(!document){
			if(deleteAll) await this.deleteAll();
			let collection = this.collect()
			if(where) collection = collection.where(...where)
			if(order_by) {
				if(order_by.desc){
					collection = collection.orderBy(order_by.key, 'desc');
				}else{
					collection = collection.orderBy(order_by.key);
				}
			}
			if(limit) collection = collection.limit(limit);
			collection = await collection.get();
			response.raw = collection;
			if(collection.docs.length > 0){
				response.exists = true;
				if(save){
					await this.insertOrUpdate({
						data: collection.docs.map((doc) => {
							return {
								...doc.data(),
								uid: doc.id,
								$isDirty: false,
							}
						})
					})
				}
			}
		}else{
			let doc = await this.doc(document).get();
			response.raw = doc;
			if(doc.exists){
				response.exists = true;
				if(save){
					await this.insertOrUpdate({
						data: {
							...doc.data(),
							uid: doc.id,
							$isDirty: false,
						}
					})
				}
			}
		}
		return response;
	}

	static async updateStore(item){
		const formatted = this.formatStoreItem(item)
		if(item.$isNew){
			this.baseCollection.add(formatted)
		}else{
			this.doc(item.uid).update(formatted)
		}
	}

	static async updateBatchStore(items){
		// console.log(items, 'items to update');
		const batch = this.firestore.batch();
		for(let item of items){
			const format = this.formatStoreItem(item);
			console.log(format);
			if(item.$softDelete){
				const ref = this.doc(item.uid);
				batch.delete(ref)
			}else if(item.$isNew){
				console.log('item is new')
				if(!item.uid || item.uid.includes('$uid')){
					const ref = this.collect().doc();
					batch.set(ref, format);
					item.uid = ref.id;
				}else{
					const ref = this.collect().doc(item.uid);
					batch.set(ref, format);
				}
				await item.$delete();
				item.$isNew = false;
				item.$isDirty = false;
			}else if(item.$isDirty){
				const ref = this.doc(item.uid);
				batch.update(ref, format);
				item.$isDirty = false;
				item.$isNew = false;
			}
		}
		const savedBatch = await batch.commit();
		await this.insertOrUpdate({ data: items});
		await this.delete((item) => item.$softDelete);
		return savedBatch
	}

	static formatStoreItem(item){
		const fields = Object.keys(this.fields()).filter(key => !this.ignoredFields().includes(key))
		return fields.reduce((obj, field) => {
			obj[field] = item[field];
			return obj
		}, {});
	}
}
